import { render, staticRenderFns } from "./ActivePositionsPanel.vue?vue&type=template&id=5c490557&scoped=true"
import script from "./ActivePositionsPanel.vue?vue&type=script&lang=js"
export * from "./ActivePositionsPanel.vue?vue&type=script&lang=js"
import style0 from "./ActivePositionsPanel.vue?vue&type=style&index=0&id=5c490557&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c490557",
  null
  
)

export default component.exports